import PropTypes from "prop-types";

// @mui material components
import Collapse from "@mui/material/Collapse";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";

// Custom styles for the SidenavCollapse
import {
    collapseItem,
    collapseIconBox,
    collapseIcon,
    collapseText,
} from "./styles/sidenavCollapse";

// Soft UI Dashboard React context
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import ArgonBox from "components/ArgonBox";
import { useArgonController } from "context";

function SidenavCollapse({ color, icon, name, children, active, noCollapse, open, ...rest }) {
    const [controller] = useArgonController();
    const { miniSidenav, darkSidenav, sidenavColor, darkMode } = controller;

    return (
        <>
            <ListItem component="li">
                <ArgonBox {...rest} sx={(theme) => collapseItem(theme, { active, darkSidenav, sidenavColor, miniSidenav, darkMode })}>
                    <ListItemIcon
                        sx={(theme) => collapseIconBox(theme, { active, darkSidenav, sidenavColor })}
                    >
                        {typeof icon === "string" ? (
                            <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
                        ) : (
                            icon
                        )}
                    </ListItemIcon>

                    <ListItemText
                        primary={name}
                        sx={(theme) => collapseText(theme, { miniSidenav, darkSidenav, active, color })}
                    />
                    {!miniSidenav && (children && (open ? <ExpandLess /> : <ExpandMore />))}
                </ArgonBox>
            </ListItem>
            {children && (
                <Collapse in={open} unmountOnExit>
                    {children}
                </Collapse>
            )}
        </>
    );
}

// Setting default values for the props of SidenavCollapse
SidenavCollapse.defaultProps = {
    color: "dark",
    active: false,
    noCollapse: false,
    children: false,
    open: false,
};

// Typechecking props for the SidenavCollapse
SidenavCollapse.propTypes = {
    color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark", "white"]),
    icon: PropTypes.node.isRequired,
    name: PropTypes.string.isRequired,
    children: PropTypes.node,
    active: PropTypes.bool,
    noCollapse: PropTypes.bool,
    open: PropTypes.bool,
};

export default SidenavCollapse;
